import { combineReducers } from "redux";
import OrganizationChart from "./OrganizationChart/Module";
import Personnel from "./Personnel/Module";
import Permission from "./Permission/reducers";
import Category from './Category/Module';
import AppSetting from "./AppSetting/Module";

const reducers = combineReducers({
  AppSetting,
  OrganizationChart,
  Personnel,
  Permission,
  Category,
});

export default reducers;
